import props from './props'
import computed from './computed'
export default {
  props,
  computed
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/professional/components/specializations/resources/index.js